const renderInline = (text) =>
    text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
        part.startsWith("**") && part.endsWith("**") ? (
            <strong key={i} className="font-semibold text-brand-ink">
                {part.slice(2, -2)}
            </strong>
        ) : (
            part
        )
    );

const MarkdownLite = ({ content }) => {
    if (!content) return null;
    const blocks = content.split(/\n\s*\n/).filter((b) => b.trim());
    return (
        <div className="space-y-5" data-testid="article-content">
            {blocks.map((block, i) => {
                const trimmed = block.trim();
                if (trimmed.startsWith("## ")) {
                    return (
                        <h2 key={i} className="pt-4 font-display text-2xl font-bold tracking-tight text-brand-ink">
                            {renderInline(trimmed.slice(3))}
                        </h2>
                    );
                }
                if (trimmed.startsWith("### ")) {
                    return (
                        <h3 key={i} className="pt-2 font-display text-xl font-semibold text-brand-ink">
                            {renderInline(trimmed.slice(4))}
                        </h3>
                    );
                }
                const lines = trimmed.split("\n").map((l) => l.trim());
                if (lines.every((l) => l.startsWith("- "))) {
                    return (
                        <ul key={i} className="space-y-2">
                            {lines.map((l, j) => (
                                <li key={j} className="flex gap-3 text-base leading-relaxed text-brand-muted">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-magenta" aria-hidden="true" />
                                    <span>{renderInline(l.slice(2))}</span>
                                </li>
                            ))}
                        </ul>
                    );
                }
                return (
                    <p key={i} className="text-base leading-relaxed text-brand-muted">
                        {renderInline(trimmed)}
                    </p>
                );
            })}
        </div>
    );
};

export default MarkdownLite;
